import { DigitalStylingStatus } from '../../../shared/types';

export function shouldDisableDelivery(
    isUploadDone: boolean,
    numberOfThumbnails: number,
    orderStatus: DigitalStylingStatus,
    disable?: boolean
): boolean {
    if (disable) {
        return true;
    }
    
    if (orderStatus === DigitalStylingStatus.Delivered) {
        return true;
    }

    return !isUploadDone || numberOfThumbnails < 1;
}
